import React from 'react';
import Headline from '$shared/components/headline';
import { useProduct } from '$shared/utils/product';
import { StyledCoreDataSubheadline, StyledPdpCoreWrapper } from './style';

export const PdpCoreDataHeadlines = () => {
    const {
        description1: title,
        description2: description,
        description3: secondaryDescription,
        propertyDetails,
    } = useProduct();

    const productLine = propertyDetails?.propertyDetails?.find(
        property => property.displayName === 'Product Line'
    )?.value;

    const formattedTitle = productLine ? `${productLine} - ${title}` : title;

    return (
        <StyledPdpCoreWrapper>
            <Headline as="h1" children={formattedTitle} noMargin size={2} />
            {description && <StyledCoreDataSubheadline children={description} />}
            {secondaryDescription && (
                <StyledCoreDataSubheadline children={secondaryDescription} />
            )}
        </StyledPdpCoreWrapper>
    );
};